import React, { useEffect, useState } from 'react';
import Fade from 'react-reveal/Fade';

export default function Loans() {
  const [success, setSuccess] = useState(false);
  const [returnUrl, setReturnUrl] = useState('null');

  useEffect(() => {
    // Determine dynamic return URL based on host
    if (typeof window !== 'undefined') {
      const searchParams = new URLSearchParams(window.location.search);
      if (searchParams.get('success') === 'true') {
        setSuccess(true);
        if (window.dataLayer) {
          window.dataLayer.push({
            event: 'loan_form_success_page',
            formName: 'Zoho CRM WebForm'
          });
        }
      }
      setReturnUrl(`${window.location.origin}/loans?success=true`);

      // Inject Zoho Analytics script
      const script = document.createElement('script');
      script.id = 'wf_anal';
      script.src = "https://crm.zohopublic.com/crm/WebFormAnalyticsServeServlet?rid=21b87dfa10465fed7d1347a00a60a8fe28aa769e97bf70497a5427f5b1fa77098f983e780754a8f884039b05e9f04107gid1ba3cad0c056f8d665d615a76bc8c62328d17562c3f606e111eea24cd7dcfc8fgid15a65cb52508b66d85471f7989eff07c1a9641d63cecdceb7b48d6a64ac70ab5gide17fc90a5e373837f6473d3b7d2a236152d8c8485db934eed32ec666601a0912&tw=19c8712f1d3dc5460b567be3100ec344750b7489a03ff7822f4905d8df8904f6";
      script.async = true;
      document.body.appendChild(script);

      return () => {
        // Clean up on component unmount
        const existingScript = document.getElementById('wf_anal');
        if (existingScript) {
          existingScript.remove();
        }
      };
    }
  }, []);

  // Form validation script based on Zoho mandatory validation
  const handleSubmit = (event) => {
    if (typeof document !== 'undefined') {
      document.charset = "UTF-8";
    }
    const form = event.target;
    
    // Mandatory fields list matching Zoho CRM configuration
    const mndFields = [
      { name: 'NAME', label: 'Loan Application Name' },
      { name: 'COBJ5CF5', label: 'First Name' },
      { name: 'COBJ5CF4', label: 'Last Name' },
      { name: 'COBJ5CF7', label: 'Middle Name' },
      { name: 'COBJ5CF3', label: 'Phone' },
      { name: 'Email', label: 'Email' },
      { name: 'COBJ5CF6', label: 'Residential Address' },
      { name: 'COBJ5CF8', label: 'State of Residence' },
      { name: 'COBJ5CF9', label: 'BVN Available' },
      { name: 'COBJ5CF2', label: 'Loan Type' },
      { name: 'COBJ5CF66', label: 'Loan Amount Needed (₦)' },
      { name: 'COBJ5CF10', label: 'Preferred Repayment Period' }
    ];

    for (let field of mndFields) {
      const fieldObj = form[field.name];
      if (fieldObj) {
        const val = fieldObj.value.trim();
        if (val.length === 0 || val === '-None-') {
          alert(`${field.label} cannot be empty.`);
          fieldObj.focus();
          event.preventDefault();
          return false;
        }
      }
    }

    // Email validation
    const emailFld = form['Email'];
    if (emailFld) {
      const emailVal = emailFld.value.trim();
      const atpos = emailVal.indexOf('@');
      const dotpos = emailVal.lastIndexOf('.');
      if (atpos < 1 || dotpos < atpos + 2 || dotpos + 2 >= emailVal.length) {
        alert('Please enter a valid email address.');
        emailFld.focus();
        event.preventDefault();
        return false;
      }
    }

    // Disable submit button on successful submit to prevent multiple requests
    const submitBtn = form.querySelector('#formsubmit');
    if (submitBtn) {
      submitBtn.setAttribute('disabled', 'true');
    }

    // Push event to Google Tag Manager dataLayer
    if (typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push({
        event: 'loan_form_submit',
        loan_type: form['COBJ5CF2']?.value || '',
        repayment_period: form['COBJ5CF10']?.value || '',
        loan_amount: form['COBJ5CF66']?.value || '',
      });
    }
  };

  // Helper for select dropdown aria-selected state
  const handleSelectChange = (event) => {
    const select = event.target;
    const options = select.options;
    for (let i = 0; i < options.length; i++) {
      if (i === select.selectedIndex) {
        options[i].setAttribute('aria-selected', 'true');
      } else {
        options[i].removeAttribute('aria-selected');
      }
    }
  };

  return (
    <div className="waya-loans-page-wrapper">
      {/* Navbar spacer */}
      <div style={{ height: '74px', background: '#fff' }} />

      {/* Hero Section */}
      <section className="loans-hero">
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-lg-8">
              <Fade bottom>
                <span className="eyebrow-badge">PRE-QUALIFY NOW</span>
                <h1 className="hero-title">
                  Get the Funding <br />
                  <span className="accent-text">Your Ambitions Deserve.</span>
                </h1>
                <p className="hero-subtext">
                  Apply in minutes for a WayaBank loan. Whether you are expanding a business, 
                  planning a trip, or securing your personal finances, we've got you covered.
                </p>
              </Fade>
            </div>
          </div>
        </div>
      </section>

      {/* Form Section */}
      <section className="loans-form-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10 col-xl-8">
              <Fade bottom delay={100}>
                {success ? (
                  // Success State
                  <div className="success-card text-center">
                    <div className="success-icon-wrapper">
                      <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="3">
                        <polyline points="20 6 9 17 4 12" />
                      </svg>
                    </div>
                    <h2 className="success-title">Submission Successful!</h2>
                    <p className="success-text">
                      Thank you for completing the WayaBank Loan Interest & Pre-Qualification form. 
                      Our loans team will review your application details and contact you shortly.
                    </p>
                    <button 
                      onClick={() => window.location.href = '/'} 
                      className="waya-btn-primary mt-4 px-5 py-3"
                    >
                      Back to Home
                    </button>
                  </div>
                ) : (
                  // Form State
                  <div className="form-card shadow-lg">
                    <div className="form-header">
                      <h3>Loan Pre-Qualification Form</h3>
                      <p>Please provide your details below. Fields marked with <span className="required-star">*</span> are mandatory.</p>
                    </div>

                    <form 
                      id="webform6108384000020788120" 
                      action="https://crm.zoho.com/crm/WebForm" 
                      name="WebForm6108384000020788120" 
                      method="POST" 
                      onSubmit={handleSubmit}
                      acceptCharset="UTF-8"
                    >
                      {/* Hidden Fields required by Zoho CRM (Do not remove) */}
                      <input type="hidden" name="xnQsjsdp" value="c2c5e53973460e3fcd9fded308ab1e301a2debe65b3b45bd3ef52ddc62a5e91c" />
                      <input type="hidden" name="zc_gad" id="zc_gad" value="" />
                      <input type="hidden" name="xmIwtLD" value="d8f69781a584144a9b9d9288a3a58dbeb4b046d93cd1f6f80cd63ff423b719c3246595006141e06b6e2b368f1a17a088" />
                      <input type="hidden" name="actionType" value="Q3VzdG9tTW9kdWxlNQ==" />
                      <input type="hidden" name="returnURL" value={returnUrl} />
                      <input type="hidden" name="aG9uZXlwb3Q" value="" />

                      <div className="form-section-title">Personal Details</div>
                      
                      <div className="row g-4 mb-4">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="COBJ5CF5">First Name <span className="required-star">*</span></label>
                            <input 
                              type="text" 
                              id="COBJ5CF5" 
                              name="COBJ5CF5" 
                              placeholder="e.g. John" 
                              maxLength="255" 
                              required 
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="COBJ5CF4">Last Name <span className="required-star">*</span></label>
                            <input 
                              type="text" 
                              id="COBJ5CF4" 
                              name="COBJ5CF4" 
                              placeholder="e.g. Doe" 
                              maxLength="255" 
                              required 
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="COBJ5CF7">Middle Name <span className="required-star">*</span></label>
                            <input 
                              type="text" 
                              id="COBJ5CF7" 
                              name="COBJ5CF7" 
                              placeholder="e.g. Alexander" 
                              maxLength="255" 
                              required 
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="Email">Email Address <span className="required-star">*</span></label>
                            <input 
                              type="email" 
                              id="Email" 
                              name="Email" 
                              placeholder="e.g. john.doe@example.com" 
                              maxLength="100" 
                              required 
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <label htmlFor="COBJ5CF3">Phone Number <span className="required-star">*</span></label>
                            <input 
                              type="text" 
                              id="COBJ5CF3" 
                              name="COBJ5CF3" 
                              placeholder="e.g. +234 801 234 5678" 
                              maxLength="30" 
                              required 
                            />
                          </div>
                        </div>
                      </div>

                      <div className="form-section-title">Residential Details</div>
                      
                      <div className="row g-4 mb-4">
                        <div className="col-md-8">
                          <div className="form-group">
                            <label htmlFor="COBJ5CF6">Residential Address <span className="required-star">*</span></label>
                            <textarea 
                              id="COBJ5CF6" 
                              name="COBJ5CF6" 
                              placeholder="Street Address, City" 
                              rows="2"
                              required 
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="COBJ5CF8">State of Residence <span className="required-star">*</span></label>
                            <select 
                              id="COBJ5CF8" 
                              name="COBJ5CF8" 
                              onChange={(e) => { handleSelectChange(e); }}
                              required
                            >
                              <option value="-None-">-Select State-</option>
                              <option value="Abia">Abia</option>
                              <option value="Adamawa">Adamawa</option>
                              <option value="Akwa Ibom">Akwa Ibom</option>
                              <option value="Anambra">Anambra</option>
                              <option value="Bauchi">Bauchi</option>
                              <option value="Bayelsa">Bayelsa</option>
                              <option value="Benue">Benue</option>
                              <option value="Borno">Borno</option>
                              <option value="Cross River">Cross River</option>
                              <option value="Delta">Delta</option>
                              <option value="Ebonyi">Ebonyi</option>
                              <option value="Edo">Edo</option>
                              <option value="Ekiti">Ekiti</option>
                              <option value="Enugu">Enugu</option>
                              <option value="Gombe">Gombe</option>
                              <option value="Imo">Imo</option>
                              <option value="Jigawa">Jigawa</option>
                              <option value="Kaduna">Kaduna</option>
                              <option value="Kano">Kano</option>
                              <option value="Katsina">Katsina</option>
                              <option value="Kebbi">Kebbi</option>
                              <option value="Kogi">Kogi</option>
                              <option value="Kwara">Kwara</option>
                              <option value="Lagos">Lagos</option>
                              <option value="Nasarawa">Nasarawa</option>
                              <option value="Niger">Niger</option>
                              <option value="Ogun">Ogun</option>
                              <option value="Ondo">Ondo</option>
                              <option value="Osun">Osun</option>
                              <option value="Oyo">Oyo</option>
                              <option value="Plateau">Plateau</option>
                              <option value="Rivers">Rivers</option>
                              <option value="Sokoto">Sokoto</option>
                              <option value="Taraba">Taraba</option>
                              <option value="Yobe">Yobe</option>
                              <option value="Zamfara">Zamfara</option>
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className="form-section-title">Loan Requirements</div>
                      
                      <div className="row g-4 mb-5">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="NAME">Loan Application Name <span className="required-star">*</span></label>
                            <input 
                              type="text" 
                              id="NAME" 
                              name="NAME" 
                              placeholder="e.g. Q3 Business Expansion Loan" 
                              maxLength="120" 
                              required 
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="COBJ5CF2">Loan Type <span className="required-star">*</span></label>
                            <select 
                              id="COBJ5CF2" 
                              name="COBJ5CF2" 
                              onChange={(e) => { handleSelectChange(e); }}
                              required
                            >
                              <option value="-None-">-Select Loan Type-</option>
                              <option value="Personal Loan">Personal Loan</option>
                              <option value="Business Loan">Business Loan</option>
                              <option value="Travel Loan/proof of funds">Travel/Proof of Funds</option>
                            </select>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="COBJ5CF66">Loan Amount Needed (₦) <span className="required-star">*</span></label>
                            <input 
                              type="text" 
                              id="COBJ5CF66" 
                              name="COBJ5CF66" 
                              placeholder="e.g. 500,000" 
                              maxLength="16" 
                              required 
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="COBJ5CF10">Preferred Repayment Period <span className="required-star">*</span></label>
                            <select 
                              id="COBJ5CF10" 
                              name="COBJ5CF10" 
                              onChange={(e) => { handleSelectChange(e); }}
                              required
                            >
                              <option value="-None-">-Select Duration-</option>
                              <option value="1 Month">1 Month</option>
                              <option value="2 Months">2 Months</option>
                              <option value="3 Months">3 Months</option>
                              <option value="4 Months">4 Months</option>
                              <option value="5 Months">5 Months</option>
                              <option value="6 Months">6 Months</option>
                              <option value="7 Months">7 Months</option>
                              <option value="8 Months">8 Months</option>
                              <option value="9 Months">9 Months</option>
                              <option value="10 Months">10 Months</option>
                              <option value="11 Months">11 Months</option>
                              <option value="12 Months">12 Months</option>
                            </select>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="COBJ5CF9">BVN Available <span className="required-star">*</span></label>
                            <select 
                              id="COBJ5CF9" 
                              name="COBJ5CF9" 
                              onChange={(e) => { handleSelectChange(e); }}
                              required
                            >
                              <option value="-None-">-Select-</option>
                              <option value="Yes">Yes</option>
                              <option value="No">No</option>
                            </select>
                          </div>
                        </div>
                      </div>

                      {/* Action Buttons */}
                      <div className="form-actions d-flex gap-3 justify-content-end">
                        <button type="reset" className="waya-btn-secondary px-4 py-3">
                          Reset
                        </button>
                        <button type="submit" id="formsubmit" className="waya-btn-primary px-5 py-3">
                          Submit Application
                        </button>
                      </div>
                    </form>
                  </div>
                )}
              </Fade>
            </div>
          </div>
        </div>
      </section>

      {/* Styled CSS */}
      <style>{`
        .waya-loans-page-wrapper {
          background-color: #fafbfc;
          min-height: 100vh;
          font-family: 'Inter', sans-serif;
          color: #1d2939;
        }

        /* Hero styles */
        .loans-hero {
          padding: 80px 0 60px;
          background: linear-gradient(180deg, #fff 0%, #f4f6f8 100%);
          border-bottom: 1px solid #eaecf0;
        }
        .eyebrow-badge {
          display: inline-block;
          background: rgba(255, 68, 0, 0.08);
          padding: 8px 18px;
          border-radius: 100px;
          color: #ff4400;
          font-weight: 700;
          font-size: 13px;
          margin-bottom: 24px;
          letter-spacing: 0.05em;
        }
        .hero-title {
          font-size: clamp(36px, 5vw, 56px);
          font-weight: 900;
          line-height: 1.15;
          margin-bottom: 24px;
          letter-spacing: -0.02em;
        }
        .accent-text {
          color: #ff4400;
        }
        .hero-subtext {
          font-size: 18px;
          line-height: 1.6;
          color: #475467;
          max-width: 680px;
          margin: 0 auto;
        }

        /* Form Area styles */
        .loans-form-section {
          padding: 80px 0 120px;
        }
        .form-card {
          background: #ffffff;
          border-radius: 24px;
          padding: 48px;
          border: 1px solid rgba(0, 0, 0, 0.05);
        }
        .form-header {
          margin-bottom: 40px;
          border-bottom: 1px solid #eaecf0;
          padding-bottom: 24px;
        }
        .form-header h3 {
          font-size: 24px;
          font-weight: 800;
          margin-bottom: 8px;
          color: #101828;
        }
        .form-header p {
          color: #667085;
          font-size: 15px;
        }
        .form-section-title {
          font-size: 16px;
          font-weight: 700;
          color: #ff4400;
          text-transform: uppercase;
          letter-spacing: 0.05em;
          margin: 32px 0 20px;
          border-left: 3px solid #ff4400;
          padding-left: 10px;
        }

        /* Form Inputs */
        .form-group {
          display: flex;
          flex-direction: column;
          gap: 8px;
        }
        .form-group label {
          font-size: 14px;
          font-weight: 600;
          color: #344054;
        }
        .required-star {
          color: #ff4400;
        }
        .form-group input, 
        .form-group select, 
        .form-group textarea {
          width: 100%;
          padding: 12px 16px;
          border: 1px solid #d0d5dd;
          border-radius: 12px;
          font-size: 15px;
          transition: all 0.3s ease;
          background: #ffffff;
          color: #1d2939;
          outline: none;
        }
        .form-group input::placeholder, 
        .form-group textarea::placeholder {
          color: #98a2b3;
        }
        .form-group input:focus, 
        .form-group select:focus, 
        .form-group textarea:focus {
          border-color: #ff4400;
          box-shadow: 0 0 0 4px rgba(255, 68, 0, 0.1);
        }

        /* Success state styles */
        .success-card {
          background: #ffffff;
          border-radius: 24px;
          padding: 60px 48px;
          border: 1px solid rgba(0, 0, 0, 0.05);
          box-shadow: 0 20px 48px rgba(0,0,0,0.06);
        }
        .success-icon-wrapper {
          width: 80px;
          height: 80px;
          border-radius: 50%;
          background: #f0fdf4;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 24px;
        }
        .success-title {
          font-size: 28px;
          font-weight: 800;
          color: #101828;
          margin-bottom: 12px;
        }
        .success-text {
          color: #475467;
          font-size: 16px;
          line-height: 1.6;
          max-width: 520px;
          margin: 0 auto;
        }

        /* Buttons styling */
        .waya-btn-primary {
          background: #ff4400;
          border: 1px solid #ff4400;
          color: #fff;
          font-weight: 600;
          font-size: 15px;
          border-radius: 12px;
          transition: all 0.3s ease;
          cursor: pointer;
        }
        .waya-btn-primary:hover {
          background: #e03c00;
          border-color: #e03c00;
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(255, 68, 0, 0.2);
        }
        .waya-btn-primary:disabled {
          background: #fda29b;
          border-color: #fda29b;
          cursor: not-allowed;
          transform: none;
          box-shadow: none;
        }
        .waya-btn-secondary {
          background: #fff;
          border: 1px solid #d0d5dd;
          color: #344054;
          font-weight: 600;
          font-size: 15px;
          border-radius: 12px;
          transition: all 0.3s ease;
          cursor: pointer;
        }
        .waya-btn-secondary:hover {
          background: #f9fafb;
          border-color: #98a2b3;
        }

        @media (max-width: 768px) {
          .loans-hero {
            padding: 60px 0 40px;
          }
          .loans-form-section {
            padding: 40px 0 80px;
          }
          .form-card {
            padding: 24px;
            border-radius: 16px;
          }
          .success-card {
            padding: 40px 24px;
            border-radius: 16px;
          }
        }
      `}</style>
    </div>
  );
}
